import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';

import {
  userLogoutAsync,
  changeSuperAdminViewAsync,
} from '../redux/asyncActions/authAsyncActions';
import { SIDEBAR } from '../CONSTANT';
import Logo from './Logo';
// import Search from "../images/search.svg";
import Times from '../images/times.svg';
import Key from '../images/key.png';
import { useNavigate } from 'react-router-dom';
const NavLink = require('react-router-dom').NavLink;

function Sidebar(props) {
  let role = '';
  const { menu } = props;
  const authObj = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, superAdmin, role: roleName } = authObj;
  if (roleName !== 'SUPERADMIN') {
    role = user && user.role;
  } else {
    if (superAdmin.isViewChanged === true) {
      role = user && user.role;
    } else {
      role = superAdmin.user && superAdmin.user.role;
    }
  }

  const [loader, setLoader] = useState(false);

  const logout = async () => {
    setLoader(true);
    navigate('/');

    localStorage.setItem('loggedInUserData', null);

    setTimeout(() => {
      dispatch(userLogoutAsync());
      setLoader(false);
    }, 1000);
  };
  const getImgUrl = (pic) => {
    return require(`../images/${pic}`);
  };
  const closeMenu = () => {
    document.body.classList.remove('side-open');
    props.closeSidebar(false);
  };
  const closeView = async () => {
    dispatch(
      changeSuperAdminViewAsync({
        token: '',
        user: '',
        expiredAt: '',
        isViewChanged: false,
      })
    );
  };

  return (
    <div
      className={`${menu === true ? 'sidebar-active' : ''}`}
      onClick={closeMenu}
    >
      <div className={`sidebar ${menu === true ? 'active' : ''}`}>
        <div className='d-flex flex-column justify-content-between h-100'>
          <div className='header d-flex align-items-center justify-content-between'>
            <div className='sidebar-menu'>
              <div className='d-flex align-items-center'>
                <Logo width='40' />
                &nbsp; Menu
              </div>
            </div>
            <div className='d-flex align-items-center justify-content-end'>
              {superAdmin.isViewChanged === true ? (
                <div>
                  <img src={Key} width='24' height='24' alt='Lock' />
                </div>
              ) : null}
              {
                // <div className="sidebar-icon">
                //   <img src={Search} width="24" height="24" alt="search" />
                // </div>
              }
              <div className='sidebar-icon' onClick={closeMenu}>
                <img src={Times} width='24' height='24' alt='close' />
              </div>
            </div>
          </div>
          <div className='content'>
            {/* {
              role && SIDEBAR[role].map((sd) => {
                return (
                  <NavLink key={sd.name} exact to={sd.url} className="d-flex align-items-center" activeClassName="active-link" onClick={closeMenu}>
                    <img src={getImgUrl(sd.icon)} alt={sd.name} width="24" height="24" /> {sd.name}
                  </NavLink>
                );
              })
            } */}

            <NavLink
              to='/'
              className='d-flex align-items-center'
              activeClassName='active-link'
              onClick={closeMenu}
            >
              Alerts
            </NavLink>
            <NavLink
              to='/'
              className='d-flex align-items-center'
              activeClassName='active-link'
              onClick={closeMenu}
            >
              Device
            </NavLink>
            <NavLink
              to='/dashboard/profile'
              className='d-flex align-items-center'
              activeClassName='active-link'
              onClick={closeMenu}
            >
              Profile
            </NavLink>
          </div>
          <div className='align-self-end logout w-100'>
            {superAdmin.isViewChanged === false ? (
              <button
                className='btn button-secondary btn-rounded btn-block btn-lg'
                onClick={logout}
                disabled={loader}
                type='button'
              >
                {loader ? (
                  <div className='d-flex align-items-center justify-content-center'>
                    <Spinner
                      animation='border'
                      size='sm'
                      variant='light'
                      className='mr-2'
                    />
                    please wait...
                  </div>
                ) : (
                  'Log out'
                )}
              </button>
            ) : (
              <button
                className='btn button-secondary btn-rounded btn-block btn-lg'
                onClick={closeView}
                type='button'
              >
                Close View
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Sidebar;